"use client";

import React, {useEffect, useState} from 'react';

import {Typography} from "@material-tailwind/react";





export default function Page() {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }, []);


    return (

        <section className={"p-2"} style={{marginTop:'20px', fontFamily:'Geneva'}}>
            <center>
                <Typography variant="h1"  className="mb-4 mt-4  font-bold ">
                    Privacy Policy
                </Typography>
            </center>
            <div className={"grid grid-cols-1 gap-2 m-10"} style={{textAlign:"justify"}}>


                <p>
                    This Privacy Policy describes in general terms how Dataworld AI, LLC ("dataworld.ai" and also
                    referred to as “we, “us” or “our”), collects and uses your Personal Information (defined below)
                    in connection with your access to and use of (i) the website located at https://dataworld.ai/
                    (collectively with all webpages and websites linked thereto or otherwise accessible therefrom
                    that are owned, operated or maintained by Dataworld.AI, the “Website”) and (ii) all data
                    storage and sharing services and applications, and any other services and applications,
                    subscribed for, purchased or otherwise available to you from time to time through the Website
                    or as result of having created an account with us (collectively, the “Services”).
                </p>
                <p>
                    <b>
                        BY ENTERING INTO A SUBSCRIPTION AGREEMENT  AND CREATING AN ACCOUNT WITH US, YOU HEREBY ACCEPT AND AGREE TO BE BOUND BY THIS PRIVACY POLICY.  THIS PRIVACY POLICY SHALL ALSO BE BINDING UPON EACH AND EVERY PERSON WHO ACCESSES OUR SERVICES THROUGH YOUR ACCOUNT.
                    </b>
                </p>
                <p>
                    This Privacy Policy does not apply to “Customer Content” (as defined in the Subscription Agreement ) transmitted to or stored by Dataworld.AI in connection with providing Services to you after you have created an account.  Customer Content is governed by the Subscription Agreement.
                </p>



                <Typography variant="h2"  className="mb-4 mt-4  font-bold ">
                    Personal Information
                </Typography>


                <div style={{padding:'20px'}}>
                    <Typography variant="h5" className="mb-4  mt-4 font-bold ">
                        Collection:
                    </Typography>

                    <p>
                        In connection with you accessing and/or using the Website and/or the Services, Dataworld.AI collects and stores the following types of information about you (collectively, “Personal Information”):
                    </p>
                    <ul className="pl-5 list-disc">
                        <li>Internet Protocol (IP) Address, which includes information about your location; </li>
                        <li>Information about your activity on the Website, including your views and interactions with content on the Website; and </li>
                        <li>Information that you provide, including your name, password, email address and phone number (but excluding your billing information, see “Billing Information” below).</li>
                    </ul>


                    <Typography variant="h5" className="mb-4 mt-4  font-bold ">
                        Use:
                    </Typography>
                    <p>
                        Dataworld.AI uses the Personal Information it collects for the following purposes:
                    </p>
                    <ul className="pl-5 list-disc">
                        <li>To maintain, improve and provide the Website and Services; </li>
                        <li>To send information, updates and advertisements to you about the Services and related products and services that may be offered from time to time by or through us; and </li>
                        <li>To communicate with you directly regarding your account.</li>
                    </ul>

                    <Typography variant="h5"  className="mb-4 mt-4  font-bold ">
                        Sharing:
                    </Typography>

                    <p>
                        We recognize that your Person Information belongs to you.  Other than the uses described above, we do not use your Personal Information.  Additionally, we do not sell your Personal Information to third parties.  Furthermore, except as provided in the Acceptable Use Policy  in connection with violations or suspected violations thereof, we do not share Personal Information with third parties.
                    </p>

                    <Typography variant="h5"  className="mb-4 mt-4  font-bold ">
                        Security:
                    </Typography>
                    <p>
                        Dataworld.AI takes commercially reasonable (in light of Dataworld.AI’s size and the nature of its activities) measures designed to prevent the accidental or unlawful access to or disclosure of your Personal Information.  YOU ACKNOWLEDGE AND AGREE THAT DATAWORLD.AI MAKES NO WARRANTIES OR GUARANTEES THAT YOUR PERSONAL INFORMATION WILL NOT BE ACCIDENTALLY OR UNLAWFULLY ACCESSED OR DISCLOSED.
                    </p>

                    <Typography variant="h5"  className="mb-4 mt-4  font-bold ">
                        Choice:
                    </Typography>
                    <p>
                        You can choose not to provide certain information requested by us.  However, this may prevent you from accessing and/or using some or all aspects of the Services.
                    </p>

                    <Typography variant="h5"  className="mb-4 mt-4  font-bold ">
                        Retention:
                    </Typography>
                    <p>
                        We keep your Personal Information for such period of time as is necessary to satisfy the purposes for which it was collected (see “Use” above).  For clarity, we keep your name and email address, even after your account or subscription has ended, for purposes of (1) sending you information related to your account/subscription termination and renewal information, options and offers and (2) sending you advertisements for the Services until you notify us in writing that you would like such advertisements to stop.  We will delete your Personal Information in accordance with any applicable laws.  To the fullest extent permitted by applicable law, you hereby waive any notice requirements now or hereafter applicable to the deletion of your Personal Information.
                    </p>


                </div>



                <Typography variant="h2"  className="mb-4 mt-4  font-bold ">
                    Billing Information
                </Typography>

                <p>
                    If you enter your billing information (credit card information) on the Website, you are actually entering that information into a website/application/portal controlled by our third-party payment processing vendor (currently, Stripe, Inc. or an affiliate thereof), and you are providing that information directly to such third-party payment processor for verification, storage and processing of payments (including recurring payments).  DATAWORLD.AI DOES NOT COLLECT, STORE OR CONTROL ACCESS TO YOUR BILLING INFORMATION.  WHILE DATAWORLD.AI BELIEVES ITS PAYMENT VENDOR IS PROFESSIONAL AND REPUTABLE, DATAWORLD.AI CANNOT AND DOES NOT MAKE ANY WARRANTIES OR GUARANTEES ABOUT ITS PAYMENT VENDOR’S SECURITY PRACTICES.  By entering your billing information, you agree that Dataworld.AI shall have no responsibility or liability to you or any other person for any misuse of your billing information by our payment vendor or by any person acting through our payment vendor or for any accidental, unauthorized or unlawful access to or disclosure of your billing information.
                </p>

                <Typography variant="h2" lassName="mb-4 mt-4  font-bold ">
                    Cookie Notice
                </Typography>

                <p>
                    Dataworld.AI does not currently use “cookies” to collect information about you.  We reserve the right to use “cookies” (small data files transferred to your device by the Website) in the future to track your interaction with the Website and collect a variety of information about you, such as the number of times you access the Website, the number of times you visit a particular page and certain types of Personal Information.  However, we will post a notice to the Website and/or to your account of our intent to start using cookies at least thirty (30) days prior to doing so.  Most browsers allow you to easily block cookies.  By continuing to use the Website and Services after the expiration of such thirty (30) day period and not blocking cookies, you consent to Dataworld.AI’s use of cookies.
                </p>

                <Typography variant="h2" className="mb-4 mt-4  font-bold ">
                    Changes
                </Typography>
                <p>
                    Dataworld.AI reserves the right, in its sole discretion, to modify, amend, supplement, replace or restate this Privacy Policy as provided in Section 8.2 of the Subscription Agreement .  It is your obligation to periodically review the Privacy Policy posted to your account to stay informed of any updates hereto.
                </p>


                <Typography variant="h2"  className="mb-4 mt-4  font-bold ">
                    Update History
                </Typography>
                <p>
                    Last updated: February 22, 2021
                </p>


            </div>


        </section>
    );

}